/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum DocumentWorkflowTemplatePurpose {
    AGREEMENT = 'AGREEMENT',
    DEAL = 'DEAL',
    DECLARATION = 'DECLARATION',
    SCHEDULE = 'SCHEDULE',
    OTHER = 'OTHER',
    SIDE_LETTER = 'SIDE_LETTER',
    FORM = 'FORM',
    POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
    ANNUAL_REPORT = 'ANNUAL_REPORT',
    VALUATION = 'VALUATION',
    RESOLUTION = 'RESOLUTION',
    UK_DEED = 'UK_DEED',
    AGREEMENT_ADVANCED_SIGNATURE = 'AGREEMENT_ADVANCED_SIGNATURE',
    NOTICE = 'NOTICE',
    NOTICE_REQUIRING_ACKNOWLEDGMENT = 'NOTICE_REQUIRING_ACKNOWLEDGMENT',
    PRE_FILLABLE_FORM = 'PRE_FILLABLE_FORM',
    GDPR_NOTICE = 'GDPR_NOTICE',
    FORM_S431 = 'FORM_S431',
    FATCA = 'FATCA',
    CRS = 'CRS',
    TAX_RESIDENCY = 'TAX_RESIDENCY',
    CUSTOM = 'CUSTOM',
}
